import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger mb-5"
}
const _hoisted_2 = {
  key: 1,
  class: "alert alert-warning mb-5"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" An active AI 24/7 location is required before enabling AI auto-reply. ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Go to AI 24/7")
const _hoisted_5 = {
  key: 3,
  class: "seq-profile-form px-2"
}
const _hoisted_6 = { class: "seq-profile-row align-items-start mb-5" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label pt-2" }, "Default AI agent for auto-reply", -1)
const _hoisted_8 = { class: "seq-profile-control" }
const _hoisted_9 = /*#__PURE__*/_createVNode("option", { value: null }, "Select an AI agent…", -1)
const _hoisted_10 = { class: "form-text text-muted fs-7 mt-2" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" AI uses this agent when replying to Messenger DMs. Social accounts with their own agent override this default in Social Fan-out Settings. ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Manage AI agents")
const _hoisted_13 = { class: "seq-profile-row align-items-center" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Auto-reply to prospects", -1)
const _hoisted_15 = { class: "seq-profile-control" }
const _hoisted_16 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label text-muted fs-7",
  for: "aiAutoReplyToggle"
}, " When enabled, AI replies using your selected AI agent. ", -1)
const _hoisted_18 = {
  key: 0,
  class: "alert alert-warning mt-5 mb-0"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "alert alert-light-primary mt-5 mb-0" }, " Replying manually in your AI 24/7 pauses AI for that conversation. You can resume AI from support flows when available. ", -1)
const _hoisted_20 = {
  key: 1,
  class: "card mt-5"
}
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = /*#__PURE__*/_createVNode("h5", { class: "card-title mb-2" }, "AI credits & usage (last 30 days)", -1)
const _hoisted_23 = {
  key: 0,
  class: "text-muted fs-7 mb-4"
}
const _hoisted_24 = { class: "mb-4" }
const _hoisted_25 = { class: "d-flex flex-wrap flex-stack gap-3 mb-2" }
const _hoisted_26 = { class: "text-muted fs-7" }
const _hoisted_27 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" AI Credit Top Up ")
const _hoisted_29 = {
  key: 1,
  class: "alert alert-warning mb-4"
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" AI auto-reply paused — insufficient AI credits. Use ")
const _hoisted_31 = /*#__PURE__*/_createVNode("strong", null, "AI Credit Top Up", -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" above to add credits. ")
const _hoisted_33 = { class: "d-flex flex-wrap gap-5 mb-4" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "text-muted fs-7" }, "Replies sent", -1)
const _hoisted_35 = { class: "fs-4 fw-bold" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "text-muted fs-7" }, "Credits used (30 days)", -1)
const _hoisted_37 = { class: "fs-4 fw-bold" }
const _hoisted_38 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_39 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-3 mb-0" }
const _hoisted_40 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-muted fs-7 fw-bold" }, [
    /*#__PURE__*/_createVNode("th", null, "Event"),
    /*#__PURE__*/_createVNode("th", { class: "text-end" }, "Count"),
    /*#__PURE__*/_createVNode("th", { class: "text-end" }, "Credits used")
  ])
], -1)
const _hoisted_41 = { class: "fs-7" }
const _hoisted_42 = { class: "text-end fs-7" }
const _hoisted_43 = { class: "text-end fs-7" }
const _hoisted_44 = {
  key: 3,
  class: "text-muted fs-7 mb-0"
}
const _hoisted_45 = {
  key: 2,
  class: "alert alert-light-warning mt-5 mb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_AiDmOnboarding = _resolveComponent("AiDmOnboarding")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.loadError)
      ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(_ctx.loadError), 1))
      : _createCommentVNode("", true),
    (!_ctx.hasGhlLocation)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_router_link, {
            to: "/settings/ai247-portal",
            class: "fw-bold"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasGhlLocation)
      ? (_openBlock(), _createBlock(_component_AiDmOnboarding, {
          key: 2,
          "integrations-url": _ctx.resolvedIntegrationsUrl,
          loading: _ctx.loading,
          completing: _ctx.completingOnboarding,
          resetting: _ctx.resettingOnboarding,
          completed: _ctx.dmOnboardingCompleted,
          onComplete: _ctx.completeOnboarding,
          onReset: _ctx.resetOnboarding
        }, null, 8, ["integrations-url", "loading", "completing", "resetting", "completed", "onComplete", "onReset"]))
      : _createCommentVNode("", true),
    (_ctx.hasGhlLocation && _ctx.dmOnboardingCompleted)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              _withDirectives(_createVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.defaultAgentId = $event)),
                class: "form-select form-select-solid",
                disabled: _ctx.saving || _ctx.loading,
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveSettings && _ctx.saveSettings(...args)))
              }, [
                _hoisted_9,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableAgents, (agent) => {
                  return (_openBlock(), _createBlock("option", {
                    key: agent.id,
                    value: agent.id
                  }, _toDisplayString(agent.name) + _toDisplayString(agent.knowledgeBaseName ? ` (${agent.knowledgeBaseName})` : ""), 9, ["value"]))
                }), 128))
              ], 40, ["disabled"]), [
                [_vModelSelect, _ctx.defaultAgentId]
              ]),
              _createVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_router_link, {
                  to: "/settings/ai247-portal?tab=ai-agents",
                  class: "fw-bold"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _withDirectives(_createVNode("input", {
                  id: "aiAutoReplyToggle",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.aiEnabled = $event)),
                  class: "form-check-input",
                  type: "checkbox",
                  disabled: _ctx.saving || !_ctx.canEnableAi || !_ctx.defaultAgentId || _ctx.usageCredits.creditsDepleted,
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveSettings && _ctx.saveSettings(...args)))
                }, null, 40, ["disabled"]), [
                  [_vModelCheckbox, _ctx.aiEnabled]
                ]),
                _hoisted_17
              ])
            ])
          ]),
          (!_ctx.globalAiEnabled)
            ? (_openBlock(), _createBlock("div", _hoisted_18, " AI auto-reply is not yet enabled for this environment. Your preference will be saved and applied when the feature is turned on. "))
            : _createCommentVNode("", true),
          _hoisted_19,
          (_ctx.usageLoaded)
            ? (_openBlock(), _createBlock("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, [
                  _hoisted_22,
                  (_ctx.usagePeriodLabel)
                    ? (_openBlock(), _createBlock("div", _hoisted_23, _toDisplayString(_ctx.usagePeriodLabel), 1))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_24, [
                    _createVNode("div", _hoisted_25, [
                      _createVNode("span", _hoisted_26, " AI credits: " + _toDisplayString(_ctx.formatNumber(_ctx.usageCredits.displayCreditsRemaining)) + " remaining ", 1),
                      _createVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-primary",
                        disabled: _ctx.topUpLoading,
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.startCreditTopUp && _ctx.startCreditTopUp(...args)))
                      }, [
                        (_ctx.topUpLoading)
                          ? (_openBlock(), _createBlock("span", _hoisted_27))
                          : _createCommentVNode("", true),
                        _hoisted_28
                      ], 8, ["disabled"])
                    ])
                  ]),
                  (_ctx.usageCredits.creditsDepleted)
                    ? (_openBlock(), _createBlock("div", _hoisted_29, [
                        _hoisted_30,
                        _hoisted_31,
                        _hoisted_32
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_33, [
                    _createVNode("div", null, [
                      _hoisted_34,
                      _createVNode("div", _hoisted_35, _toDisplayString(_ctx.usageSummary.chatReplyCount), 1)
                    ]),
                    _createVNode("div", null, [
                      _hoisted_36,
                      _createVNode("div", _hoisted_37, _toDisplayString(_ctx.formatNumber(_ctx.usageCredits.displayCreditsUsedInPeriod)), 1)
                    ])
                  ]),
                  (_ctx.usageByEventType.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_38, [
                        _createVNode("table", _hoisted_39, [
                          _hoisted_40,
                          _createVNode("tbody", null, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.usageByEventType, (row) => {
                              return (_openBlock(), _createBlock("tr", {
                                key: row.eventType
                              }, [
                                _createVNode("td", _hoisted_41, _toDisplayString(_ctx.formatEventType(row.eventType)), 1),
                                _createVNode("td", _hoisted_42, _toDisplayString(_ctx.formatNumber(row.count)), 1),
                                _createVNode("td", _hoisted_43, _toDisplayString(_ctx.formatNumber(row.displayCreditsUsed)), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_44, "No AI usage recorded in the last 30 days yet."))
                ])
              ]))
            : (_ctx.usageError)
              ? (_openBlock(), _createBlock("div", _hoisted_45, _toDisplayString(_ctx.usageError), 1))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}